/** Decrement button is disabled when the value is at or below this. */
export const DURATION_DECREMENT_FLOOR = 15;

/** Lock the −15 button once stepping down would breach the floor. */
export function shouldLockDecrement(value: unknown): boolean {
  return typeof value === 'number' && value <= DURATION_DECREMENT_FLOOR;
}
